import { z } from "zod";

export const GitInteropPulsarError = z.object({
  errorType: z.string(),
  errorMessage: z.string(),
  trace: z.array(z.string()),
});
export type GitInteropPulsarError = z.infer<typeof GitInteropPulsarError>;
